export default __webpack_public_path__ + "static/colin-signature-5c6db11f7ed18e53f4874cba1cad9c22.png";